export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	}
};
